import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, LockIcon, SmartphoneIcon, ClockIcon, RefreshCwIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'vip'>('vip');
  return <section className="bg-[#0a0a0a] py-12 px-4" id="pricing" data-id="element-127">
      <div className="max-w-2xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-130">
            Elegí tu Pack
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4 mb-8" data-id="element-131">
          {/* VIP Plan */}
          <motion.div layout onClick={() => setSelectedPlan('vip')} className={`cursor-pointer rounded-2xl border-2 transition-all duration-300 relative ${selectedPlan === 'vip' ? 'border-yellow-500 bg-[#18181b] shadow-[0_0_30px_rgba(202,138,4,0.15)] p-6' : 'border-zinc-800 bg-[#0a0a0a] hover:border-zinc-600 px-5 py-3'}`} data-id="element-132">
            {selectedPlan === 'vip' && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-black px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-133">
                ⭐ Más Elegido
              </div>}

            <div className={`flex items-center justify-between ${selectedPlan === 'vip' ? 'mb-4 mt-2' : ''}`} data-id="element-134">
              <div className="flex items-center gap-3" data-id="element-135">
                <h3 className={`font-bold ${selectedPlan === 'vip' ? 'text-xl text-yellow-500' : 'text-base text-zinc-400'}`} data-id="element-136">
                  PACK PRO COMPLETO
                </h3>
                {selectedPlan !== 'vip' && <span className="text-zinc-500 text-sm" data-id="element-137">$29.990 ARS</span>}
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'vip' ? 'border-yellow-500' : 'border-zinc-600'}`} data-id="element-138">
                {selectedPlan === 'vip' && <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-139" />}
              </div>
            </div>

            <AnimatePresence data-id="element-140">
              {selectedPlan === 'vip' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-141">
                  <ul className="space-y-2.5 mb-4" data-id="element-142">
                    {['6 Tomos PDF completos', '6 Bonos Gratis (valorados en $26.950)', 'Acceso inmediato por descarga', 'Tuyo para siempre', 'Apto celular, tablet y computadora'].map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-143">
                        <CheckIcon className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-id="element-144" />
                        <span className="text-zinc-300 text-sm" data-id="element-145">{feature}</span>
                      </li>)}
                    <li className="flex items-start gap-2" data-id="element-146">
                      <CheckIcon className="w-4 h-4 text-yellow-500 shrink-0 mt-0.5" data-id="element-147" />
                      <span className="text-white text-sm font-medium" data-id="element-148">
                        Master en Proteínas Vegetales PDF (tofu casero, seitán,
                        tempeh, hamburguesas, chorizos vegetales)
                      </span>
                    </li>
                  </ul>
                  <div className="text-center pt-2 border-t border-zinc-800" data-id="element-149">
                    <span className="text-3xl font-black text-white" data-id="element-150">
                      $29.990
                    </span>
                    <span className="text-zinc-400 ml-1 text-sm" data-id="element-151">ARS</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Base Plan */}
          <motion.div layout onClick={() => setSelectedPlan('base')} className={`cursor-pointer rounded-2xl border-2 transition-all duration-300 relative ${selectedPlan === 'base' ? 'border-emerald-500 bg-[#18181b] p-6' : 'border-zinc-800 bg-[#0a0a0a] hover:border-zinc-600 px-5 py-3'}`} data-id="element-152">
            <div className={`flex items-center justify-between ${selectedPlan === 'base' ? 'mb-4' : ''}`} data-id="element-153">
              <div className="flex items-center gap-3" data-id="element-154">
                <h3 className={`font-bold ${selectedPlan === 'base' ? 'text-xl text-white' : 'text-base text-zinc-400'}`} data-id="element-155">
                  PACK BASE
                </h3>
                {selectedPlan !== 'base' && <span className="text-zinc-500 text-sm" data-id="element-156">$19.990 ARS</span>}
              </div>
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-emerald-500' : 'border-zinc-600'}`} data-id="element-157">
                {selectedPlan === 'base' && <div className="w-3 h-3 bg-emerald-500 rounded-full" data-id="element-158" />}
              </div>
            </div>

            <AnimatePresence data-id="element-159">
              {selectedPlan === 'base' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-160">
                  <ul className="space-y-2.5 mb-4" data-id="element-161">
                    {['6 Tomos PDF completos', '6 Bonos Gratis (valorados en $26.950)', 'Acceso inmediato por descarga', 'Tuyo para siempre', 'Apto celular, tablet y computadora'].map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-162">
                        <CheckIcon className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-id="element-163" />
                        <span className="text-zinc-300 text-sm" data-id="element-164">{feature}</span>
                      </li>)}
                  </ul>
                  <div className="text-center pt-2 border-t border-zinc-800" data-id="element-165">
                    <span className="text-3xl font-black text-white" data-id="element-166">
                      $19.990
                    </span>
                    <span className="text-zinc-400 ml-1 text-sm" data-id="element-167">ARS</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>
        </div>

        {/* CTA */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-168">
          <CTAButton href={selectedPlan === 'vip' ? 'https://checkout.rosetadigital.com/cart/46376655913113:1' : 'https://checkout.rosetadigital.com/cart/46376655683737:1'} className="w-full mb-5" onClick={e => {
          e.preventDefault();
          const pixelId = '2088725711974596';
          const contentName = selectedPlan === 'vip' ? 'Pack PRO Completo' : 'Pack Base';
          const contentId = selectedPlan === 'vip' ? '46376655913113' : '46376655683737';
          const value = selectedPlan === 'vip' ? 29990 : 19990;
          const currency = 'ARS';
          const url = selectedPlan === 'vip' ? 'https://checkout.rosetadigital.com/cart/46376655913113:1' : 'https://checkout.rosetadigital.com/cart/46376655683737:1';
          // Método 1: fbq si está disponible
          const w = window as any;
          if (typeof w.fbq === 'function') {
            w.fbq('track', 'InitiateCheckout', {
              content_name: contentName,
              content_ids: [contentId],
              value: value,
              currency: currency
            });
          }
          // Método 2: Imagen directa (respaldo infalible)
          const img = new Image(1, 1);
          const params = new URLSearchParams({
            id: pixelId,
            ev: 'InitiateCheckout',
            noscript: '1',
            'cd[content_name]': contentName,
            'cd[value]': String(value),
            'cd[currency]': currency
          });
          img.src = `https://www.facebook.com/tr?${params.toString()}`;
          // Abrir checkout después de que el pixel dispare
          setTimeout(() => {
            window.location.href = url;
          }, 300);
        }} data-id="element-169">
            ✅ COMPRAR AHORA — ACCESO INMEDIATO
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs text-zinc-400" data-id="element-170">
            <div className="flex items-center gap-1.5" data-id="element-171">
              <LockIcon size={14} data-id="element-172" /> Pago 100% Seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-173">
              <ClockIcon size={14} data-id="element-174" /> Acceso Inmediato
            </div>
            <div className="flex items-center gap-1.5" data-id="element-175">
              <SmartphoneIcon size={14} data-id="element-176" /> Apto Celular
            </div>
            <div className="flex items-center gap-1.5" data-id="element-177">
              <RefreshCwIcon size={14} data-id="element-178" /> Garantía 7 Días
            </div>
          </div>
        </div>
      </div>
    </section>;
}